import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { createComponent } from '../utils';
var Legend = createComponent({
    name: 'Legend',
    tag: 'legend',
    style: function (_a) {
        var theme = _a.theme, _b = _a.color, color = _b === void 0 ? theme.colors.greyDarkest : _b;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 700;\n    margin-bottom: 8px;\n    font-size: 18px;\n    color: ", ";\n  "], ["\n    font-weight: 700;\n    margin-bottom: 8px;\n    font-size: 18px;\n    color: ", ";\n  "])), color);
    },
});
var Container = styled.fieldset(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 0;\n  padding: 0;\n  margin: 0;\n\n  * + & {\n    margin-top: 1.5rem;\n  }\n"], ["\n  border: 0;\n  padding: 0;\n  margin: 0;\n\n  * + & {\n    margin-top: 1.5rem;\n  }\n"])));
export var Fieldset = function (_a) {
    var legend = _a.legend, children = _a.children;
    return (React.createElement(Container, null,
        legend && React.createElement(Legend, null, legend),
        children));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Fieldset.js.map